module.exports = __webpack_public_path__ + "static/media/slide-two.3f22c916.webp";